import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FaStar, FaShoppingCart, FaHeart, FaHome } from 'react-icons/fa';
import ProductCard from '../components/ProductCard';

function Home() {
  const products = [
    {
      id: 1,
      name: 'Premium Whey Protein Powder',
      shortDescription: 'High-quality protein supplement for muscle growth and recovery',
      price: 45.99,
      rating: 5,
      reviews: 234,
      image: '/images/1.jpg',
      badge: 'Best Seller'
    },
    {
      id: 2,
      name: 'Professional Yoga Mat',
      shortDescription: 'Non-slip eco-friendly yoga mat with extra cushioning',
      price: 32.99,
      rating: 5,
      reviews: 189,
      image: '/images/2.jpg',
      badge: 'Popular'
    },
    {
      id: 3,
      name: 'Resistance Bands Set',
      shortDescription: 'Complete set of 5 resistance bands for full body workout',
      price: 24.99,
      rating: 4,
      reviews: 156,
      image: '/images/3.jpg',
      badge: 'New'
    },
    {
      id: 4,
      name: 'Smart Fitness Tracker',
      shortDescription: 'Advanced fitness tracker with heart rate monitor and GPS',
      price: 79.99,
      rating: 5,
      reviews: 312,
      image: '/images/4.jpg',
      badge: 'Featured'
    },
    {
      id: 5,
      name: 'Insulated Water Bottle',
      shortDescription: 'Premium stainless steel bottle keeps drinks cold for 24 hours',
      price: 18.99,
      rating: 5,
      reviews: 278,
      image: '/images/5.jpg',
      badge: 'Eco-Friendly'
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Fitness Health Blog - Premium Wellness Products for Your Healthy Lifestyle</title>
        <meta name="description" content="Shop premium fitness and health products including protein powder, yoga mats, resistance bands, fitness trackers and more. Quality wellness products for your healthy lifestyle." />
        <meta property="og:title" content="Fitness Health Blog - Premium Wellness Products" />
        <meta property="og:description" content="Shop premium fitness and health products for your wellness journey" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://topfitnessproducts.com" />
      </Helmet>

      <section className="hero-section">
        <h2>Welcome to Your Wellness Journey</h2>
        <p>Discover premium quality fitness and health products designed to support your active lifestyle and wellness goals</p>
      </section>

      <section className="welcome-section">
        <div className="welcome-greetings">
          <h3>Greetings from Around the World</h3>
          <div className="greetings-grid">
            <div className="greeting-item">Hello - English</div>
            <div className="greeting-item">Hola - Spanish</div>
            <div className="greeting-item">Bonjour - French</div>
            <div className="greeting-item">Ciao - Italian</div>
            <div className="greeting-item">Hallo - German</div>
            <div className="greeting-item">Olá - Portuguese</div>
          </div>
        </div>
      </section>

      <section className="features-section">
        <h2>Why Choose Our Products</h2>
        <p>We are committed to providing you with the highest quality fitness and health products</p>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon"><FaStar /></div>
            <h3>Premium Quality</h3>
            <p>Every product is carefully selected and tested to meet the highest quality standards for your health and fitness journey</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon"><FaHeart /></div>
            <h3>Health Focused</h3>
            <p>All our products are designed with your wellness in mind, using safe and effective ingredients and materials</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon"><FaShoppingCart /></div>
            <h3>Fast Delivery</h3>
            <p>Quick and reliable shipping across the United Kingdom, ensuring your products arrive when you need them</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon"><FaHome /></div>
            <h3>Customer Support</h3>
            <p>Our dedicated team is here to help you make the right choices for your fitness and wellness goals</p>
          </div>
        </div>

        <div className="stats-section">
          <div className="stat-item">
            <div className="stat-number">15000+</div>
            <div className="stat-label">Happy Customers</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">8</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">500+</div>
            <div className="stat-label">Products Available</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">98%</div>
            <div className="stat-label">Satisfaction Rate</div>
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <Link to="/about" className="cta-button">Learn More About Us</Link>
        </div>
      </section>

      <section className="about-products-section">
        <h2>Premium Fitness and Health Products</h2>
        
        <p>
          At Fitness Health Blog, we understand that achieving your wellness goals requires more than just determination. 
          It requires the right tools, the right nutrition, and the right support. That is why we have dedicated ourselves 
          to sourcing and providing only the finest quality fitness and health products available in the United Kingdom.
        </p>
        
        <p>
          Our carefully curated selection includes everything you need for a complete wellness journey. From premium protein 
          supplements that support muscle growth and recovery, to eco-friendly yoga mats that provide the perfect foundation 
          for your practice. Each product in our catalog has been rigorously tested and vetted to ensure it meets our 
          exceptionally high standards for quality, safety, and effectiveness.
        </p>

        <h3>Quality You Can Trust</h3>
        
        <p>
          We partner exclusively with trusted manufacturers and suppliers who share our commitment to excellence. Every product 
          we offer is manufactured using the highest quality ingredients and materials, following strict quality control protocols. 
          Our protein powders contain pure, high-grade whey with no artificial fillers. Our fitness equipment is built to last, 
          using durable materials that can withstand intensive daily use.
        </p>

        <h3>Certified and Tested</h3>
        
        <p>
          All our nutritional supplements are certified by leading health and safety organizations. We ensure complete transparency 
          in our ingredient lists and manufacturing processes. Our products undergo regular third-party testing to verify purity, 
          potency, and safety. You can shop with confidence knowing that every item has been thoroughly vetted by health and 
          fitness professionals.
        </p>

        <h3>Supporting Your Wellness Journey</h3>
        
        <p>
          Whether you are a professional athlete, a fitness enthusiast, or just beginning your wellness journey, we have products 
          tailored to your needs. Our range includes specialized supplements for different fitness goals, equipment for various 
          exercise styles, and accessories to support your daily wellness routine. We believe that everyone deserves access to 
          premium quality health products, which is why we work hard to keep our prices competitive without compromising on quality.
        </p>

        <h3>Our Promise to You</h3>
        
        <p>
          When you choose Fitness Health Blog, you are choosing a partner in your health and wellness journey. We promise to 
          continue bringing you innovative, effective, and safe products that help you achieve your fitness goals. Our customer 
          service team is always available to answer your questions and help you find the perfect products for your needs. 
          We stand behind every product we sell with our quality guarantee and hassle-free return policy.
        </p>

        <p>
          Join thousands of satisfied customers across the United Kingdom who have made Fitness Health Blog their trusted source 
          for premium fitness and health products. Start your wellness journey today with products you can trust.
        </p>
      </section>

      <section className="products-section">
        <h2>Our Featured Products</h2>
        <div className="products-grid">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;